// Small shared controls for the Menu area.

import { useEffect, useState } from 'react';
import './menu.css';

/** A dollars text input that speaks cents to its owner. */
export function CentsInput(props: {
  value: number;
  onChange: (cents: number) => void;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  title?: string;
}) {
  const fmt = (c: number) => (c === 0 ? '' : (c / 100).toFixed(2));
  const [text, setText] = useState(fmt(props.value));

  // Re-sync when the owner's value changes out from under the text.
  useEffect(() => {
    const parsed = Math.round(parseFloat(text || '0') * 100);
    if ((Number.isFinite(parsed) ? parsed : 0) !== props.value) setText(fmt(props.value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value]);

  return (
    <input
      className={`input money mn-num ${props.className ?? ''}`}
      inputMode="decimal"
      placeholder={props.placeholder ?? '0.00'}
      disabled={props.disabled}
      title={props.title}
      value={text}
      onChange={(e) => {
        setText(e.target.value);
        const parsed = Math.round(parseFloat(e.target.value) * 100);
        props.onChange(Number.isFinite(parsed) && parsed >= 0 ? parsed : 0);
      }}
      onBlur={() => setText(fmt(props.value))}
    />
  );
}

/** The teal availability switch. */
export function Switch(props: { on: boolean; onToggle: () => void; disabled?: boolean; title?: string }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={props.on}
      title={props.title}
      className={'mn-switch' + (props.on ? ' on' : '')}
      disabled={props.disabled}
      onClick={props.onToggle}
    />
  );
}

/** Nullable integer input for min/max overrides — blank means "no override". */
export function OverrideInput(props: {
  value: number | null;
  onChange: (v: number | null) => void;
  placeholder: string;
  disabled?: boolean;
}) {
  return (
    <input
      className="input mn-num-sm money"
      inputMode="numeric"
      placeholder={props.placeholder}
      disabled={props.disabled}
      value={props.value ?? ''}
      onChange={(e) => {
        const t = e.target.value.trim();
        if (t === '') return props.onChange(null);
        const n = parseInt(t, 10);
        if (Number.isFinite(n) && n >= 0) props.onChange(n);
      }}
    />
  );
}
